import apiClient from "./client.js";

export async function fetchRumWorkspaceSummary() {
  const res = await apiClient.get("/rum/summary");
  return res.data.data;
}

export async function fetchRumProjects() {
  const res = await apiClient.get("/rum/projects");
  return res.data.data;
}

export async function createRumProject({ name, allowed_origins, sample_rate }) {
  const res = await apiClient.post("/rum/projects", {
    name,
    allowed_origins,
    sample_rate,
  });
  return res.data.data;
}

export async function updateRumProject(id, patch) {
  const res = await apiClient.patch(`/rum/projects/${id}`, patch);
  return res.data.data;
}

export async function deleteRumProject(id) {
  await apiClient.delete(`/rum/projects/${id}`);
}

export async function fetchRumProjectSummary(id, window = "24h", path = null) {
  const params = { window };
  if (path) params.path = path;
  const res = await apiClient.get(`/rum/projects/${id}/summary`, { params });
  return res.data.data;
}

export async function fetchRumProjectTrend(id, days = 7) {
  const res = await apiClient.get(`/rum/projects/${id}/trend`, {
    params: { days },
  });
  return res.data.data;
}

export async function fetchRumProjectSessions(id, days = 7) {
  const res = await apiClient.get(`/rum/projects/${id}/sessions`, {
    params: { days },
  });
  return res.data.data;
}

export async function fetchRumAlertRules(projectId) {
  const res = await apiClient.get(`/rum/projects/${projectId}/alert-rules`);
  return res.data.data;
}

export async function createRumAlertRule(projectId, rule) {
  const res = await apiClient.post(`/rum/projects/${projectId}/alert-rules`, rule);
  return res.data.data;
}

export async function patchRumAlertRule(ruleId, patch) {
  const res = await apiClient.patch(`/rum/alert-rules/${ruleId}`, patch);
  return res.data.data;
}

export async function deleteRumAlertRule(ruleId) {
  await apiClient.delete(`/rum/alert-rules/${ruleId}`);
}
